// extracted by mini-css-extract-plugin
export default {"button":"styles_button__oqsnk","disabled":"styles_disabled__iP62U","icon":"styles_icon__wfMLJ"};